<template>
  <span>{{ fechaIngreso }}</span>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  name: "fechaIngreso",
  computed: {
    fechaIngreso() {
      if (this.params.data.fecha_ingreso) {
        const fechaIngreso = this.params.data.fecha_ingreso;
        return this.$moment(fechaIngreso).format("DD-MM-YYYY");
      }
      return "";
    },
  },
});
</script>
